import { render, staticRenderFns } from "./PieChartFinanceiro.vue?vue&type=template&id=16af3e18"
import script from "./PieChartFinanceiro.vue?vue&type=script&lang=js"
export * from "./PieChartFinanceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports